import React from "react";
import styled from "styled-components";

const Privacy = () => {
  return (
    <PageWrapper>
      <Hero>
        <HeroContent>
          <h1>Privacy Policy</h1>
          <p>How Pragan Tech Solutions protects and respects your data</p>
        </HeroContent>
      </Hero>

      <ContentWrapper>
        <Section>
          <h2>1. Our Commitment to Your Privacy</h2>
          <p>
            At <strong>Pragan Tech Solutions</strong>, your privacy is a priority.
            We are committed to protecting your personal information and using
            it only in ways that help us deliver better software, consulting, and
            digital services.
          </p>
        </Section>

        <Section>
          <h2>2. Information We Collect</h2>
          <List>
            <li>Name, email, phone number when you contact us</li>
            <li>Project or service details you share with us</li>
            <li>Website usage data such as IP address, browser type, and pages visited</li>
          </List>
        </Section>

        <Section>
          <h2>3. How We Use Your Information</h2>
          <List>
            <li>To respond to your inquiries and provide support</li>
            <li>To deliver software development and consulting services</li>
            <li>To improve our website, tools, and user experience</li>
            <li>To send important updates or service-related communications</li>
          </List>
        </Section>

        <Section>
          <h2>4. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your
            data against unauthorized access, loss, or misuse. Your information
            is handled with strict confidentiality.
          </p>
        </Section>

        <Section>
          <h2>5. Sharing of Information</h2>
          <p>
            We do not sell or rent your personal data. Information may only be
            shared with trusted partners when required to deliver our services,
            and always under strict confidentiality agreements.
          </p>
        </Section>

        <Section>
          <h2>6. Cookies & Tracking</h2>
          <p>
            Our website may use cookies and analytics tools to understand how
            visitors interact with our platform so we can improve performance
            and usability.
          </p>
        </Section>

        <Section>
          <h2>7. Your Rights</h2>
          <List>
            <li>Request access to your personal data</li>
            <li>Ask for corrections or deletion</li>
            <li>Withdraw consent for marketing communications</li>
          </List>
        </Section>

        <Section highlight>
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact:
          </p>
          <ContactBox>
            <strong>Pragan Tech Solutions</strong>
            <span>sales@pragantechsolutions.com</span>
            <span>+91 8072487998</span>
            {/* <span>First floor, Joseph Complex, 1, Xavier's Colony, Tirunelveli, Tamil Nadu 627005, India</span> */}
          </ContactBox>
        </Section>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Privacy;
const PageWrapper = styled.div`
  background: radial-gradient(circle at top, #fff5ee, #f7f2ff);
  min-height: 100vh;
`;

const Hero = styled.div`
  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  padding: 120px 20px 80px;
  text-align: center;
  color: #fff;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: auto;

  h1 {
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  p {
    opacity: 0.9;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 32px;
    }
  }
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: -60px auto 80px;
  padding: 0 20px;
  display: grid;
  gap: 30px;
`;

const Section = styled.div`
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(12px);
  border-radius: 22px;
  padding: 35px 40px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.08);
  position: relative;

  h2 {
    font-size: 22px;
    margin-bottom: 12px;
    background: linear-gradient(135deg,#ff8a3d,#d55bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 14px;
    color: #555;
    line-height: 1.7;
  }

  ${({ highlight }) =>
    highlight &&
    `
      border: 2px solid rgba(213, 91, 255, 0.3);
      box-shadow: 0 0 0 6px rgba(213, 91, 255, 0.08);
    `}
`;

const List = styled.ul`
  padding-left: 20px;
  margin: 10px 0;

  li {
    margin-bottom: 10px;
    font-size: 14px;
    color: #555;
  }
`;

const ContactBox = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: #333;
`;
